<template>

    <nav class="navbar navbar-expand-lg navbar-dark sticky-top p-0">

        <div class="container">
            <button class="navbar-toggler m-2" type="button" data-toggle="collapse" data-target="#navbarsExample08" aria-controls="navbarsExample08" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <a class="navbar-brand m-0" href="#">
                <router-link to="/" class="nav-link">
                    <img src="https://i.ibb.co/CJ3pFfS/roft-dark-full.png" width="90" height="75">
                </router-link>
            </a>

            <div class="collapse navbar-collapse justify-content-md-end" id="navbarsExample08">
                <ul class="navbar-nav d-flex align-items-center">
                    <li class="nav-item">
                        <router-link to="/" class="nav-link">Home</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/softwares" class="nav-link">Software</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/designs" class="nav-link">Designs</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/about" class="nav-link">About</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/hire-me" class="nav-link text-primary">Hire me</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="py-5">
        <router-view/>
    </div>

    <footer class="page-footer font-small">
        <!-- Footer Elements -->
        <div class="container">
            <!-- Social buttons -->
            <ul class="list-unstyled list-inline text-center d-flex justify-content-center">
                <li class="list-inline-item">
                    <a href="https://www.instagram.com/roftsoftware" target="_blank">
                        <img src="https://i.ibb.co/9tK9181/instagram.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://twitter.com/RoftSoftware" target="_blank">
                        <img src="https://i.ibb.co/QpyqB2W/twitter.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://www.pinterest.pt/roftcomp/_saved/" target="_blank">
                        <img src="https://i.ibb.co/9pyQqQ6/pinterest-1.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://gumroad.com/roft" target="_blank">
                        <img src="https://i.ibb.co/RYKNWcT/shopping-bag.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="mailto:roft.comp@gmail.com">
                        <img src="https://i.ibb.co/zJRQGP9/google.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://play.google.com/store/apps/developer?id=ROFT" target="_blank">
                        <img src="https://i.ibb.co/TcKXkMR/playstore.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://github.com/ribeiro1505" target="_blank">
                        <img src="https://i.ibb.co/0q3jwL3/github.png" class="social-icon" />
                    </a>
                </li>
            </ul>
            <!-- Social buttons -->
        </div>
        <!-- Footer Elements -->
        <div class="footer-copyright text-center py-3"> © 2021 ROFT. All Rights Reserved.</div>
    </footer>

</template>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;
    background-color: #000000;
}

.social-icon{
    height: 20px;
}

.list-inline-item{
    margin-left: 4vw;
    margin-right: 4vw;
}

.navbar {
    background-color: #000000d7 !important;
}

.header-logo {
    text-align: center;
    background-color: #000000;
}

.logo {
    height: 13vh;
    margin-top: 2vh;
}

.nav-link {
    color: #ffffff;
}

footer {
    text-align: center;
    color: #505050;
}

nav a {
    font-weight: bold;
    color: #00000033;
}

nav a.router-link-exact-active {
    color: #ffffff !important;
}

</style>